// Draw order of an animal next to a farm object (owner 2026-09-30: a cow beside the obora was painted
// behind it). Objects sort by their footprint's front corner — right for anything in front of or
// behind them, wrong for something BESIDE a multi-cell building. The building's two walls facing the
// viewer are at x = x1 and y = y1: past either one the animal is in front of it, else behind.
// "Past a wall" counts only alongside it (within a cell of its span): off a corner diagonally,
// a row behind the object, the two don't overlap on screen, and lifting the animal above the
// object would also lift it above every crop in front of its feet (owner 2026-10-20, trees).
const NEAR = 3;   // cells: beyond this the sprites can't overlap

export function depthAmongObjects(depth, p, boxes) {
  let d = depth;
  for (const b of boxes) {
    if (p.x < b.x0 - NEAR || p.x > b.x1 + NEAR || p.y < b.y0 - NEAR || p.y > b.y1 + NEAR) continue;
    const inFront = p.x >= b.x1 || p.y >= b.y1;
    const alongside = (p.x >= b.x1 && p.y > b.y0 - 1) || (p.y >= b.y1 && p.x > b.x0 - 1);
    if (alongside && d <= b.depth) d = b.depth + 0.5;
    else if (!inFront && d >= b.depth) d = b.depth - 0.5;
  }
  return d;
}
